var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKmxStaking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M16 0c8.8365 0 16 7.16345 16 16 0 8.8366-7.1635 16-16 16-8.83655 0-16-7.1634-16-16C0 7.16345 7.16345 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M16.6736 28.9137c5.4275 0 9.8274-4.2575 9.8274-9.5095 0-5.2519-4.3999-9.50942-9.8274-9.50942-5.4275 0-9.82741 4.25752-9.82741 9.50942 0 5.252 4.39991 9.5095 9.82741 9.5095Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M18.3136 9.93622c-1.8609-1.39133-4.8503-1.85897-5.2868-4.53046-.8225.77261-1.3006 1.70208-1.1363 2.92285-4.61563.49592-7.92863 2.96279-9.45398 6.71389 1.05691-.5551 2.20084-.9319 3.38427-1.1146-2.87053 3.2346-3.41495 8.0252-.79187 12.9073.14491-1.1714.54174-2.2991 1.16405-3.3077.94432 3.9614 4.29463 6.7762 7.83823 7.6043-4.97366-2.2929-6.51182-5.9782-4.64503-9.017.25146-1.7849 1.04033-3.2434 2.45973-4.3288-1.1468-.242-2.33843-.1808-3.45351.1773 1.81101-1.4979 4.14381-2.2423 6.50331-2.0752-.6861-.6723-1.5233-1.1763-2.4439-1.4712 5.0749-.5709 8.7926 3.5936 11.8086 1.1637-3.697-1.2227-3.8137-4.0554-5.9468-5.64438Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M5.74185 12.1629c-1.32607.668-2.47298 1.6491-3.34341 2.8601 1.04646-.5645 2.17924-.9478 3.35125-1.1341 1.11197-1.2574 2.48887-2.2473 4.02956-2.8967-1.7644.4721-3.23463 1.1925-4.45301 2.1208l.41561-.9501Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.8298 11.5537c-.6633-.2151-1.3803.333-1.9284.219.4895.1915 1.0406.9586 1.6236 1.0666.561.1052.9691-.1483 1.5232 0-.4667-.2376-.5541-1.0695-1.2184-1.2856Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M27.1356 10.0773c.0336 1.3123-.155 2.4445-.6263 3.3569C25.012 7.65036 18.473 5.32455 18.9748.322754 15.6559 1.9764 14.121 5.21463 15.9473 8.60854c.7902.40945 1.6081.79077 2.2778 1.29178 2.1286 1.58648 2.3518 4.45898 6.0342 5.67978-2.4359 5.2128-11.3187.5554-14.94474 6.4794-1.86292 3.0369-.55516 7.243 4.65134 9.0649 4.9032 1.1478 10.8544-.7782 14.0152-4.6332-1.5473.3704-3.1628.365-4.7076-.0155 6.9488-2.7188 8.3494-11.1981 3.8621-16.3984Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M8.94474 22.0168c-1.9089 3.0206-.56886 7.2041 4.76616 9.0163-3.91191-1.7851-4.62045-5.0311-3.0415-7.5379 2.912-4.6142 11.6194-.6464 13.8583-5.2972-.6493-.2045-1.265-.4957-1.829-.865-4.0187 2.0147-10.6072-.3096-13.75396 4.6838Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M15.9255 8.60254c.8913.44726.9674.47997 1.6744.8861-1.4707-3.34226-.6096-6.10489 1.3375-9.147576-3.2943 1.652656-4.8247 4.869576-3.0119 8.261476Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    d: "M26.4953 13.4171c-.8101-3.1503-2.7561-4.88835-4.6165-6.95592 3.0214 3.86902 4.3674 8.02222 3.0042 12.64102.8846-.2633 1.6891-.7412 2.3409-1.3906.1138 4.4678-3.0518 8.3659-8.6985 9.6309 1.8005-.0145 3.3852-.3261 4.7542-.8676 6.902-2.7218 8.2926-11.2105 3.8374-16.4165.0334 1.3117-.154 2.4453-.6217 3.3587Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.15688 21.4854c0 .3504-.28401.6344-.63435.6344s-.63435-.284-.63435-.6344V17.373c0-.3504.28401-.6344.63435-.6344s.63435.284.63435.6344v.1015c0 .6791.84128.9958 1.28912.4854l.9101-1.0374c.1026-.1169.2505-.1839.406-.1839.465 0 .7126.5486.405.8973l-.7015.7954c-.3015.3417-.3393.8421-.0926 1.2253l.9849 1.5301c.2593.4029-.0299.9331-.5091.9331-.2064 0-.3987-.1052-.5099-.2791l-.5992-.9366c-.3079-.4812-.99097-.5335-1.36849-.1047l-.01929.0219c-.1257.1428-.19504.3264-.19504.5167v.1474ZM19.8369 21.4877c0 .3491-.283.6321-.6321.6321s-.6322-.283-.6322-.6321v-3.2105c0-.0751-.0176-.1451-.053-.2102-.0324-.065-.0781-.1213-.137-.1688-.056-.0501-.1223-.0888-.199-.1164-.0766-.0275-.1591-.0412-.2475-.0412s-.1709.0137-.2476.0412c-.0766.0276-.1444.0663-.2033.1164-.056.0475-.1002.1038-.1326.1688-.0324.0651-.0487.1351-.0487.2102v3.2082c0 .3504-.284.6344-.6343.6344s-.6344-.284-.6344-.6344v-3.2082c0-.0751-.0162-.1451-.0486-.2102-.0324-.065-.0781-.1213-.137-.1688-.056-.0501-.1223-.0888-.1989-.1164-.0767-.0275-.1592-.0412-.2476-.0412-.0884 0-.1709.0137-.2475.0412-.0767.0276-.1444.0663-.2034.1164-.056.0475-.1002.1038-.1326.1688-.0324.0651-.0486.1351-.0486.2102v3.2082c0 .3504-.284.6344-.6344.6344-.3503 0-.6343-.284-.6343-.6344v-3.2082c0-.2227.0486-.4316.1459-.6267.1002-.1976.2357-.369.4066-.5141.1739-.1476.3758-.2627.6057-.3452.2328-.0851.4803-.1276.7426-.1276.2358 0 .4627.0362.6808.1088.3713.1193.8005.1208 1.1714 0 .2181-.0726.445-.1088.6808-.1088.2623 0 .5083.0425.7382.1276.2328.0825.4347.1976.6056.3452.1739.1451.3095.3165.4067.5141.1002.1951.1503.404.1503.6267v3.2105ZM25.1854 21.1347c.2969.4108.0034.9851-.5034.9851-.2024 0-.3921-.0986-.5084-.2642l-.1411-.201c-.4351-.6195-1.3529-.6203-1.789-.0015l-.1443.2048c-.1158.1642-.3041.2619-.5051.2619-.5041 0-.7961-.5713-.5007-.9799l.712-.9849c.3132-.4332.3132-1.0184 0-1.4516l-.712-.9849c-.2954-.4086-.0034-.9799.5007-.9799.201 0 .3893.0977.5051.262l.1443.2047c.4361.6188 1.3539.6181 1.789-.0015l.1411-.201c.1163-.1656.306-.2642.5084-.2642.5068 0 .8003.5743.5034.9851l-.7082.9797c-.3132.4332-.3132 1.0184 0 1.4516l.7082.9797Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.84706 -50.44626 65.14624 51.45845 -7.84104 39.0994)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25FF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(53.04 -2.931278 7.65706) scale(32.2994 31.2681)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.72566 3.04422 -3.26027 6.132 4.05493 13.4081)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F82FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(58.916 5.203006 9.844443) scale(36.3793 32.4116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EB1D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(43.34 -16.80314 21.24935) scale(19.9772 20.0931)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3190C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BD6E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(70.755 7.543048 11.096818) scale(10.1525 6.36596)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41ABE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.8806 21.30648 -16.38547 7.59855 19.6971 6.04459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FFFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 6.84619,
    x2: 6.00008,
    y1: 24.5969,
    y2: 25.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00F2DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#00D0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502682,
    stopColor: "#00677E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#009ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB986"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmxStaking);
export default __webpack_public_path__ + "static/media/kmx-staking.7c1c6060.svg";
export { ForwardRef as ReactComponent };